import React from "react";
import { useTranslation } from "react-i18next";
import "../styles/ContactsPage.css";
import ContactForm from "./ContactForm";
import QuickContactForm from "./QuickContactForm";
import HomepageButton from "./HomepageButton";
import InnerPageHeader from "./InnerPageHeader";
import Footer from "./Footer";
import { FaWhatsapp, FaEnvelope } from "react-icons/fa";

export default function ContactsPage() {
  const { t } = useTranslation("contactsPage");
  const { t: tc } = useTranslation("common");

  return (
    <div className="contactpage">
      <InnerPageHeader
        title={t("title")}
        subtitle={t("subtitle")}
      />

      <div className="contactpage__main">

        <div className="contactpage__left">
          <QuickContactForm />

          <div className="contactpage__info">
            <p className="contactpage__info-title">{t("directTitle")}</p>
            <p className="contactpage__info-heading">{t("directHeading")}</p>
            <div className="contactpage__info-links">
              <a
                href="https://wa.me/351913987913"
                target="_blank"
                rel="noreferrer"
                className="contactpage__info-link"
              >
                <FaWhatsapp />
                +351 913 987 913
              </a>
              <a
                href="mailto:info@connectmoon.pt"
                className="contactpage__info-link"
              >
                <FaEnvelope />
                info@connectmoon.pt
              </a>
            </div>
          </div>
        </div>

        <div className="contactpage__right">
          <ContactForm />
        </div>

      </div>

      <div className="contactpage__back">
        <HomepageButton label={tc("back")} href="/#homepage" />
      </div>

      <Footer />
    </div>
  );
}
